import React, { useContext } from 'react';
import './RowCountDropdown.css';
import { ReportContext } from '../context/ReportProvider';

const rowOptions = [10, 20, 50, 100, 250, 500];

const RowCountDropdown: React.FC = () => {
    const reportContext = useContext(ReportContext);
    const pageSize: number = reportContext?.reportPageSize ?? 20;
    const currentPage: number = reportContext?.reportCurrentPageNumber ?? 1;
    const totalCount: number = reportContext?.reportTotalCount ?? 0;

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newSize = parseInt(event.target.value, 10);
        reportContext?.setReportCurrentPageNumber(1);
        reportContext?.setReportPageSize(newSize);
    };

    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalCount);

    return (
        <div className="row-count-container">
            <label className="row-count-label">
                Show{' '}
                <select value={pageSize} onChange={handleChange} className="row-count-select">
                    {rowOptions.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>{' '}
                rows
            </label>
            <span className="row-count-summary">
                Showing {start}-{end} of {totalCount}
            </span>
        </div>
    );
};

export default RowCountDropdown;
